import React, { CSSProperties } from 'react';
import Utils from 'libs/Utils';
import ColorPalette from 'utils/ColorPalette';

export interface CustomIconProps {
  color?: string;
  active?: boolean;
  width?: number;
  height?: number;
  style?: CSSProperties;
}

export const setColor = ({ color, active }: CustomIconProps): string => {
  if (color) {
    return color;
  }
  if (active) {
    return ColorPalette.primary;
  }
  const appTheme = Utils.getAppTheme();
  return appTheme === 'dark' ? ColorPalette.iconDark : ColorPalette.iconLight;
};
